import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
    PaymentVerification,
    PaymentVerificationPayload,
} from '../models/payment-verification';

@Injectable({
    providedIn: 'root',
})
export class PaymentVerificationsService {
    constructor(private http: HttpClient) {}

    getAllPaymentVerifications(): Observable<PaymentVerification[]> {
        return this.http.get<PaymentVerification[]>(
            '/admin/payments/verification'
        );
    }

    getPaymentVerificationByPurchaseOrderId(
        id: string
    ): Observable<PaymentVerification> {
        return this.http.get<PaymentVerification>(
            '/admin/payments/verification/' + id
        );
    }

    verifyPayment(verification: PaymentVerificationPayload): Observable<any> {
        return this.http.post<any>(
            '/admin/payments/verification',
            verification
        );
    }

    

    getProofOfPaymentDocument(id: string): Observable<any> {
        return this.http.get('/admin/documents/' + id + '/download', {
            observe: 'response',
            responseType: 'blob',
        });
    }
}
